import _ from 'underscore';
/**
 * Checks if the segmentation option matches the chosen variant
 *
 * @param {*} optionValue
 * @param {*} variant
 *
 * @returns {Boolean}
 */
export default (function (optionValue, variant) {
    if (_.isString(variant)) {
        if (_.isArray(optionValue)) {
            return optionValue.some(function (option) {
                return _.isEqual(option, variant);
            });
        }
        return _.isEqual(optionValue, variant);
    }
    if (_.isNumber(variant)) {
        if (_.isArray(optionValue)) {
            return optionValue.some(function (option) {
                return _.isEqual(parseInt(option, 10), variant);
            });
        }
        return _.isEqual(parseInt(optionValue), variant);
    }
    if (_.isObject(variant) && _.isObject(optionValue)) {
        // all option property values must match variant object properties
        return _.isMatch(variant, optionValue);
    }

    if (_.isArray(variant) && _.isArray(optionValue)) {
        return optionValue.every(function (option) {
            return variant.indexOf(option) !== -1;
        });
    }

    return false;
});


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/platform/segmentation/CheckSegmentationOption.js
// module id = 317
// module chunks = 0